import { NewLeadFormData } from '@/controllers/Lead';
import { ROUTES } from '@/router';
import { Navigation, Options } from '@/services/Navigation';
import { ActivityType } from '@/types';

import { SalesRepInfo } from './types';

export const leadCreationFormToRepInfo = (form: NewLeadFormData): SalesRepInfo => {
  return {
    id: form.salesRepresentativeId,
    firstName: form.salesRepresentativeFirstName || '',
    lastName: form.salesRepresentativeLastName,
    email: form.salesRepresentativeEmail || '',
    phoneNumber: form.salesRepresentativePhoneNumber || '',
  };
};

export const goToRepDashboard = (info: SalesRepInfo): void => {
  const routeParams: Options = { search: `?type=${ActivityType.Lead}` };
  const isNotCompletedSalesRepInfo = Object.values(info).some(value => value === '');

  if (isNotCompletedSalesRepInfo) {
    routeParams.state = { info };
  }
  Navigation.goTo(ROUTES.Private.Dashboard.ActivityList, routeParams);
};
